/**
 * THE FLEET ACCOUNT'S workers.dev ADDRESS: the subdomain Cloudflare gives the primary account, and the one composer
 * every `https://<script>.<subdomain>` origin reads. Before 2026-09-30 the subdomain was re-typed inside each origin
 * (`const/urls-connect.ts`, `const/federa-tools.ts`), so an account move had to find every copy by grep.
 *
 * Created via the const-add flow (subfile mode). Imports RELATIVELY, like `const/urls-connect.ts` which reads it.
 */

import { httpsOrigin } from './brand-hostnames.ts';

// CLOUDFLARE

/** The fleet (primary) account's workers.dev subdomain: every worker deployed with `workersDev: true` answers at
 *  `https://<script name>.<this>`. An ACCOUNT fact, set once in the Cloudflare dashboard, so it is spelled once here. */
export const WORKERS_DEV_SUBDOMAIN = 'smartagent.workers.dev';

/**
 * The workers.dev HOSTNAME one deployed script answers on (the script is a `WORKER_DEPLOY_NAMES` `dev`/`prod` value) --
 * the host half, for a caller that puts its own scheme on it (`wss://`). Only meaningful for a worker whose env block
 * sets `workersDev: true`; every other worker answers nowhere here.
 *
 * @runtime-derived-ssot-helper composes {@link WORKERS_DEV_SUBDOMAIN}; no second spelling.
 */
export function workersDevHost(scriptName: string): string {
	return `${scriptName}.${WORKERS_DEV_SUBDOMAIN}`;
}

/**
 * The public workers.dev ORIGIN one deployed script answers on.
 *
 * @runtime-derived-ssot-helper composes `httpsOrigin` over {@link workersDevHost}; no second spelling.
 */
export function workersDevOrigin(scriptName: string): string {
	return httpsOrigin(workersDevHost(scriptName));
}
